import { gql } from '@apollo/client';

const getProtectionPlanQuery = () => {

  const ProtectionPlanQuery = gql`
    query ProtectionPlan($protectionPlanParentId: String!, $storeId: String!, $price: Float!) {
      protectionPlan(protectionPlanParentId: $protectionPlanParentId, storeId: $storeId, price: $price) {
        itemId
        price
        termLength
        category
        detailsUrl
      }
    }
`;
  return ProtectionPlanQuery;
};
export default getProtectionPlanQuery;
